import React from 'react';
import styled from 'styled-components';

import { NavigationButtonIconWrapper } from '../NavigationButtonIconWrapper';

import { breakpoints, colors, spacing } from '../../constants';

interface IProps {
    backgroundGrey?: boolean;
    className?: string;
    helpText?: string;
    onClick?(): void;
}

const BaseNavigationButton: React.FC<IProps> = ({
    backgroundGrey,
    children,
    className,
    helpText,
    onClick,
}) => {
    return (
        <div className={className} role="button" onClick={onClick}>
            <span>{helpText}</span>
            <NavigationButtonIconWrapper backgroundGrey={backgroundGrey}>
                {children}
            </NavigationButtonIconWrapper>
        </div>
    );
};

export const NavigationButton = styled(BaseNavigationButton)`
    cursor: pointer;
    margin: 0 ${spacing.sm};
    display: flex;
    align-items: center;

    span {
        display: none;

        @media (${breakpoints.mediumMin}) {
            display: inline;
            color: ${colors.greenDark};
        }
    }

    svg {
        width: 16px;
        height: 16px;

        @media (${breakpoints.mediumMin}) {
            width: 22px;
            height: 22px;
        }
    }
`;
